/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserForOrganizationSitesAdminRequest } from '../../models/user-for-organization-sites-admin-request';

export interface PostAdministrationOrganizationSitesUserV3$Params {
      body: UserForOrganizationSitesAdminRequest
}

export function postAdministrationOrganizationSitesUserV3(http: HttpClient, rootUrl: string, params: PostAdministrationOrganizationSitesUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postAdministrationOrganizationSitesUserV3.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postAdministrationOrganizationSitesUserV3.PATH = '/administration/organization-sites/users';
